/** Проверка строк экрана «Запрос клиента» (перенос validateRequestRow_ из Validation.gs). */
import { isBlank, isInt, normalizeArticle, parseNumber } from '../engine/values.js';
import { REQUEST_COLUMNS } from './columns.js';
const err = (message) => ({ ok: false, message });
/** Строка заполнена: есть что-то, кроме пустоты (OEM сам по себе тоже считается — его надо проверить). */
export function isRequestRowActive(row) {
    return REQUEST_COLUMNS.some((c) => !isBlank(row[c.key]));
}
export function computeRequestChecks(header, rows) {
    const active = rows.map(isRequestRowActive);
    // Номера строк (как в таблице, с 1) для каждого OEM — чтобы в ошибке показать, где повтор
    const counts = {};
    rows.forEach((r, i) => {
        if (!active[i])
            return;
        const a = normalizeArticle(r.art);
        if (a)
            (counts[a] ??= []).push(i + 1);
    });
    let count = 0;
    let errors = 0;
    const checks = rows.map((row, i) => {
        if (!active[i])
            return null;
        count++;
        const res = validateRow(row, header, counts);
        if (!res.ok)
            errors++;
        return res;
    });
    return { checks, rows: count, errors };
}
function validateRow(row, header, counts) {
    const art = normalizeArticle(row.art);
    if (!art)
        return err('Нет OEM');
    if ((counts[art]?.length ?? 0) > 1)
        return err(`OEM повторяется в строках ${counts[art].join(', ')}`);
    const qtyP = parseNumber(row.qty);
    if (qtyP.kind === 'blank')
        return err('Не указано количество');
    if (qtyP.kind === 'invalid')
        return err('Кол-во не число');
    const qty = qtyP.value;
    if (qty < 0)
        return err('Кол-во меньше 0');
    if (!isInt(qty))
        return err('Кол-во не целое');
    if (header.mode === 'new' && qty === 0)
        return err('Кол-во 0 в новом запросе');
    const priceP = parseNumber(row.price);
    if (priceP.kind === 'invalid')
        return err('Цена не число');
    if (priceP.kind === 'number' && priceP.value < 0)
        return err('Цена меньше 0');
    return { ok: true };
}
//# sourceMappingURL=validate.js.map